/* eslint-disable menti-react/filename-convention--jsx */
import * as React from 'react';

interface ToolbarModals {
  showResultsModal: boolean;
  toggleResultsModal: () => void;
  resetResultsFromSlide: boolean;
  setResetResultsFromSlide: (value: boolean) => void;
  modalDeleteSessionId: number | null;
  setModalDeleteSessionId: (sessionId: number | null) => void;
}

const defaultState: ToolbarModals = {
  showResultsModal: false,
  toggleResultsModal: () => {},
  resetResultsFromSlide: false,
  setResetResultsFromSlide: () => false,
  modalDeleteSessionId: null,
  setModalDeleteSessionId: () => {},
};
const context = React.createContext<ToolbarModals>(defaultState);
context.displayName = 'ToolbarModalsContext';

const Provider = context.Provider;

interface Props {
  children: React.ReactNode;
}

export const ToolbarModalsProvider = ({ children }: Props) => {
  const [showResultsModal, setShowResultsModal] = React.useState(false);
  const toggleResultsModal = () => setShowResultsModal((prev) => !prev);
  const [resetResultsFromSlide, setResetResultsFromSlide] =
    React.useState(false);
  const [modalDeleteSessionId, setModalDeleteSessionId] = React.useState<
    number | null
  >(null);

  return (
    <Provider
      value={{
        showResultsModal,
        toggleResultsModal,
        resetResultsFromSlide,
        setResetResultsFromSlide,
        modalDeleteSessionId,
        setModalDeleteSessionId,
      }}
    >
      {children}
    </Provider>
  );
};

export const useToolbarModals = () => React.useContext(context);
